import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  avatarContainer: {
    padding: 20,
    border: `1px solid ${theme.colors.light.ghostWhite}`,
    borderRadius: 8,
  },
  avatarImg: {
    display: 'block',
    margin: '0 auto',

    '@media(max-width: 379px)': {
      width: '100%',
    },
  },
  changeAvatarButton: {
    marginTop: 20,
    padding: '14px 0',
    fontWeight: 400,
    fontSize: theme.fonts.sizes.font12PX,
    textTransform: 'none',
    backgroundColor: theme.colors.light.freshPowder,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: theme.colors.light.freshPowder,
    },
  },
  informationTitle: {
    margin: '20px 0 9px 0',
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font16PX,
  },
  informationItem: {
    marginBottom: 12,
    padding: '13px 17px',
    fontWeight: 500,
    fontSize: theme.fonts.sizes.font14PX,
    border: `1px solid ${theme.colors.light.ghostWhite}`,
    borderRadius: 6,
  },
}));

export const useStylesButtonSecondary = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    marginTop: 16,
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.steelBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
    },
  },
}));
